<template>
  <div class="head">
    <!-- 布局logo -->
    <div class="logo">
      <logo :logo="menuLogoImg"/>
    </div>
    <!-- 布局导航栏操作区域 -->
    <div class="right-nav">
      <el-avatar :size="24" :src="avatar"></el-avatar>
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          {{ name }}
          <i class="el-icon-caret-bottom"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="loginOut">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/layout/Logo";
import { getUserName, getLoginImg } from "@/common/js/storage"
export default {
  components: {
    Logo,
  },

  data() {
    return {
      name: '',
      avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      menuLogoImg: require('../../assets/fire-logo.png'),
    }
  },

  created() {
    if (getLoginImg()) {
      this.avatar = getLoginImg()
    }
    this.name = getUserName()
  },

  methods: {
    handleCommand(command) {
      if (command === 'loginOut') {
        this.signOut()
      }
    },
    signOut() {
      this.$emit('loginOut')
    }
  }
}
</script>

<style lang='scss' scoped>
.head {
  @include flex-between;
  padding-right: 30px;
  background: $bg-head;
  .right-nav {
    height: 56px;
    line-height: 56px;
    position: relative;
    .el-avatar {
      margin-right: 10px;
      vertical-align: middle;
    }
    .signOut {
      margin-left: 15px;
      padding-left: 15px;
      border-left: 1px solid $color-LightGrey;
    }
    span {
      font-size: $fs-medium-s;
      color: $color-white;
    }
  }
  .el-avatar {
    background: $bg-white;
  }
  .el-dropdown-link {
    cursor: pointer;
  }
}
</style>